import { useState } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RootPatronState } from '../../common/use-patron-selector';
import useMenuClick from '../../common/use-menu-click';
import { Button, NewContentIcon } from '../ui';
import SiteHeaderSubmitPopover from './site-header-submit-popover';
import SiteHeaderSubmitImage from './site-header-submit-image';
import SiteHeaderSubmitLinks from './site-header-submit-links';
import { trackSubmitClick } from '../../models/content-submission/analytics';
import './site-header-submit.scss';
import { ContentType } from '../../models/content/types';
import Tooltip from '../tooltip/tooltip';
import { uiSelectors } from '../../models/ui';

type StateProps = ReturnType<typeof mapStateToProps>;

type SiteHeaderSubmitProps = StateProps;

const SiteHeaderSubmit = ({ isMinimized }: SiteHeaderSubmitProps) => {
  const [isActive, setIsActive] = useState(false);
  const [contentType, setContentType] = useState<ContentType | null>(null);
  const { t } = useTranslation();
  const tabIndexProps = isMinimized ? { tabIndex: -1 } : {};

  const handleTriggerClick = () => {
    setIsActive((a) => !a);
    if (!isActive) {
      trackSubmitClick();
    }
  };

  const handleLinkOver = setContentType;

  const ref = useMenuClick({
    disabled: !isActive,
    onClick: handleTriggerClick,
  });

  const submitButtonLabel = t('content_submission.title');

  return (
    <>
      {/* Prefetch image assets */}
      <link rel="prefetch" href="/images/submit-image-video.svg" />
      <link rel="prefetch" href="/images/submit-image-image.svg" />
      <link rel="prefetch" href="/images/submit-image-note.svg" />
      <link rel="prefetch" href="/images/submit-image-article.svg" />
      <link rel="prefetch" href="/images/submit-image-link.svg" />
      <link rel="prefetch" href="/images/submit-image-default.svg" />

      <div className="site-header-submit" ref={ref}>
        <Tooltip
          aria-hidden
          text={submitButtonLabel}
          options={{ placement: 'bottom' }}
        >
          <Button
            className="submit-link"
            onClick={handleTriggerClick}
            aria-label={submitButtonLabel}
            iconComponent={<NewContentIcon />}
            aria-expanded={isActive}
            {...tabIndexProps}
          />
        </Tooltip>

        {isActive ? (
          <SiteHeaderSubmitPopover>
            <SiteHeaderSubmitImage contentType={contentType} />

            <SiteHeaderSubmitLinks
              onLinkOver={handleLinkOver}
              onClick={() => setIsActive(false)}
            />
          </SiteHeaderSubmitPopover>
        ) : null}
      </div>
    </>
  );
};

const mapStateToProps = (state: RootPatronState) => ({
  isMinimized: uiSelectors.getMinimizeHeader(state),
});

export default connect(mapStateToProps)(SiteHeaderSubmit);
